import { Product, TagType } from '@/features/products/shared';
import React, { memo } from 'react';
import { TFunction } from 'next-i18next';
import TitlePartial from '@/components/ui/Title';
import { ProductLoop } from '@/components/loop/ProductLoop';
import { PagePath } from '@/layouts/shared';
import { Link } from '@/components';
type NewProductProps = {
  title: string;
  description?: string;
  products: Product[];
  t: TFunction;
  cateCode: string;
  isHideSeeMore?: boolean;
};
const NewProduct = ({ title, description, products, t, cateCode, isHideSeeMore }: NewProductProps) => {
  return (
    <div className="tw-w-full">
      <TitlePartial
        name={title}
        className="_title-product-detail tw-text-lg  tw-text-center md:tw-text-2xl"
        cs="tw-w-40 md:tw-w-auto"
      />
      <h3 className="tw-text-xl tw-text-secondary-70 tw-text-center tw-line-clamp-2 lg:tw-w-4/5 tw-mx-auto">
        {description}
      </h3>
      <div className="tw-grid tw-grid-cols-2 md:tw-grid-cols-4 tw-gap-2 tw-mt-10 lg:tw-gap-4">
        {products.map((p, index) => {
          return (
            [0, 1, 2, 3].includes(index) && (
              <div key={p.product_code} className={`tw-w-full`}>
                <ProductLoop catCode={p.cat_code} p={p} t={t} />
              </div>
            )
          );
        })}
      </div>
      <div className={`tw-mt-10 tw-text-center tw-text-md ${isHideSeeMore && 'tw-hidden'}`}>
        <Link
          className="tw-italic tw-text-center !tw-underline"
          url={{ pathname: PagePath.CategoryPage, query: { id: cateCode } }}
        >
          {t('detail.label.seemore')}
        </Link>
      </div>
    </div>
  );
};

export default memo(NewProduct);
